import React, { useState } from 'react';
import { Box, Popover } from '@mui/material';
import TimelineDateCalendar from '../UI/TimelineDateCalendar';
import TimelineDateNavigator from '../UI/TimelineDateNavigator';

const TimelineHeaderControls = ({
  selectedDate,
  onDateChange,
  calendarEntries = [],
  sx = {},
}) => {
  const [datePickerAnchor, setDatePickerAnchor] = useState(null);

  const handleDateChange = (newDate) => {
    onDateChange?.(newDate);
    setDatePickerAnchor(null);
  };

  const handleDatePickerOpen = (event) => {
    setDatePickerAnchor(event.currentTarget);
  };

  const handleDatePickerClose = () => {
    setDatePickerAnchor(null);
  };


  return (
    <Box sx={{ ...sx }}>
      <TimelineDateNavigator
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
        onOpenCalendar={handleDatePickerOpen}
        entries={calendarEntries}
        sx={{
          px: 0,
        }}
      />

      <Popover
        open={Boolean(datePickerAnchor)}
        anchorEl={datePickerAnchor}
        onClose={handleDatePickerClose}
        disableScrollLock
        disablePortal
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        disableAutoFocus
      >
        <Box sx={{ p: 1 }}>
          <TimelineDateCalendar
            entries={calendarEntries}
            value={selectedDate}
            onChange={(date) => handleDateChange(date)}
            allowFuture
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default TimelineHeaderControls;
